
export default {
  name: 'ComponentFooter',
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    logoLoading: true
  }),
  computed: {
    footerItems() {
      if (this.data) {
        let data = JSON.parse(JSON.stringify(this.data))
        return data.title.map((item) => {
          item.children = []
          var key = item.link_text
            .replace(/&/gi, 'and')
            .replace(/\s/gi, '-')
            .toLowerCase()
          if (data[key]) {
            item.children = data[key]
          }
          return item
        })
      }
      return null
    }
  },
  created() {},
  mounted() {},
  methods: {
    openUsercentricOverlay() {
      if (window && window.UC_UI) {
        window.UC_UI.showSecondLayer()
      }
    },
    getAltTextByUrl(str) {
      return new URL(str).hostname.replace('www.', '')
    },
    getIconText(str) {
      let url = new URL(str)
      return url.hostname
    },
    getIconPath(str, color) {
      let hostname = this.getIconText(str)
      let iconName = hostname.replace(new RegExp(/\./gi), '_')
      let clr = color ? `_${color}` : ''
      let iconPath = `/icons/${iconName}${clr}.svg`
      return iconPath
    },
    trackItem(text) {
      if (text.includes('@')) {
        this.pushEvent({
          eventName: 'contact_mail'
        })
      }
      this.pushEvent({
        eventName: 'navigation_footer',
        eventDetails: {
          navigation_item: text
        }
      })
    }
  }
}
